import React from 'react';
import { useNavigate } from 'react-router-dom';
import { env } from '../../config/env';
import '../../assets/css/theme.css';
import '../../assets/css/landing.css';

/** Ticker under the hero – taken from the store's own categories. */
const MARQUEE_ITEMS = [
  'Sarees',
  'Kurtis',
  'Suits',
  'Banarasi',
  'Cotton',
  'Jacquard',
  'Handpainted',
  'Digital Prints',
];

const Diamond = () => (
  <svg width="10" height="10" viewBox="0 0 10 10" fill="currentColor" aria-hidden="true">
    <path d="M5 0l5 5-5 5-5-5z" />
  </svg>
);

const HeroSection = () => {
  const navigate = useNavigate();

  const scrollToCollections = () => {
    document.getElementById('collections')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  return (
    <>
      <section className="ffh-hero">
        <video className="ffh-hero-video" autoPlay loop muted playsInline>
          <source src={env.heroVideoUrl} type="video/mp4" />
        </video>
        <div className="ffh-hero-shade" />

        <div className="ffh-hero-inner">
          <p className="ffh-eyebrow ffh-eyebrow--light ffh-eyebrow--left">The season edit</p>
          <h1 className="ffh-hero-title">
            Fashion <em>Frame</em>
          </h1>
          <p className="ffh-hero-sub">Upgrade your Style</p>
          <p className="ffh-hero-copy">
            Sarees, kurtis and suits — curated with intention, worn with purpose.
          </p>
          <div className="ffh-hero-cta">
            <button
              type="button"
              className="ffh-btn ffh-btn--gold"
              onClick={() => navigate('/products')}
              aria-label="Shop Now"
            >
              Shop now
              <svg width="14" height="14" viewBox="0 0 14 14" fill="none" aria-hidden="true">
                <path d="M2 7H12M8 3L12 7L8 11" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </button>
            <button type="button" className="ffh-btn ffh-btn--ghost" onClick={scrollToCollections}>
              Explore collections
            </button>
          </div>
        </div>

        <div className="ffh-hero-side">www.fashionframe.in</div>

        <div className="ffh-hero-badge" aria-hidden="true">
          <svg viewBox="0 0 100 100" className="ffh-hero-badge-ring">
            <defs>
              <path id="ffh-hero-badge-path" d="M 50,50 m -37,0 a 37,37 0 1,1 74,0 a 37,37 0 1,1 -74,0" />
            </defs>
            <text>
              <textPath href="#ffh-hero-badge-path" textLength="228" lengthAdjust="spacing">
                FASHION FRAME · NEW COLLECTION ·
              </textPath>
            </text>
          </svg>
          <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
            <path d="M12 1l2.6 7.4L22 11l-7.4 2.6L12 21l-2.6-7.4L2 11l7.4-2.6L12 1z" />
          </svg>
        </div>

        <div className="ffh-scroll" aria-hidden="true">
          Scroll <i />
        </div>
      </section>

      <div className="ffh-marquee" aria-hidden="true">
        <div className="ffh-marquee-track">
          {[0, 1].map((copy) =>
            MARQUEE_ITEMS.map((item) => (
              <span className="ffh-marquee-item" key={`${copy}-${item}`}>
                {item}
                <Diamond />
              </span>
            ))
          )}
        </div>
      </div>
    </>
  );
};

export default HeroSection;